module.exports = __webpack_public_path__ + "img/fwdbutton.aafcd586.png";